/* src/app/views/payment-signature/payment-signature.component.scss */
body .ui-corner-all {
  border-radius: 5px;
}
.margin-top-5 {
  margin-top: 5%;
}
.label-name-car {
  color: #2861A4;
  font-weight: bold;
  font-style: normal;
}
.client-data-title {
  font-weight: normal;
  font-style: normal;
  font-size: 36px;
  line-height: 50px;
  color: #000000;
  padding: 2%;
}
.client-data-field-name {
  font-weight: bold;
  font-style: normal;
  font-size: 20px;
  color: #000000;
}
.client-data-field-sub-name {
  font-weight: bold;
  font-style: normal;
  font-size: 16px;
  color: #000000;
}
.client-data-field-sub-name-14 {
  font-weight: normal;
  font-style: normal;
  font-size: 14px;
  color: #000000;
}
.client-data-field-text {
  font-weight: normal;
  font-style: normal;
  font-size: 18px;
  color: #000000;
  text-align: justify;
  text-justify: inter-word;
}
.client-data-field-sub-text {
  font-weight: normal;
  font-style: normal;
  font-size: 12px;
  color: #000000;
  text-align: justify;
}
.client-data-apply_margin_bottom {
  margin-bottom: 3%;
}
.client-data-message {
  display: grid;
  margin-top: 4px;
}
form {
  border-radius: unset;
  padding: unset;
  box-shadow: unset;
}
.legal-main-card {
  background: #ffffff;
  border: 1px solid #d8e0eb;
  border-radius: 14px;
  box-shadow: 0 10px 24px rgba(16, 43, 78, 0.08);
  overflow: hidden;
  padding: 12px 0 16px;
  margin: 0 auto 24px;
  width: 100%;
  box-sizing: border-box;
}
.btn-next {
  width: auto;
  min-width: 170px;
  height: 48px;
  padding: 0 16px;
  margin-bottom: 2px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
}
.btn-next-processing {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  pointer-events: none;
}
.btn-back {
  width: auto;
  min-width: 170px;
  height: 48px;
  padding: 0 16px;
  margin-bottom: 2px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
}
.search {
  position: relative;
  color: #aaa;
  font-size: 16px;
}
.search .fa-search {
  position: absolute;
  top: 20px;
}
.search .fa-search {
  left: 90%;
  color: #002F6C;
}
.invalid-feedback {
  font-weight: normal;
  font-style: normal;
  font-size: 12px;
  color: #a80303;
  text-align: justify;
}
.contract-error-message {
  display: block;
  text-align: center;
}
.button-position {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  width: calc(100% - 56px);
  margin: 20px 28px 0;
  padding-top: 18px;
  border-top: 1px solid #d9d9d9;
  box-sizing: border-box;
}
.signature-consent-section {
  width: calc(100% - 56px);
  max-width: none;
  margin: 32px 28px 0;
  padding: 0;
  background: transparent;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  display: grid;
  gap: 0;
}
.consent-card,
.signature-meta-card,
.signature-panel {
  background: transparent;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  box-sizing: border-box;
}
.consent-card {
  padding: 0 0 18px;
}
.consent-check {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  line-height: 1.5;
  transition:
    box-shadow 180ms ease,
    background-color 180ms ease,
    border-color 180ms ease;
  border-radius: 10px;
  padding: 6px 8px;
  margin-left: -8px;
}
.consent-check.terms-focus-active {
  background: #eef6ff;
  box-shadow: 0 0 0 3px rgba(4, 108, 234, 0.2);
}
:host ::ng-deep .consent-check.terms-focus-active .p-checkbox .p-checkbox-box {
  border-color: #046cea !important;
  box-shadow: 0 0 0 3px rgba(4, 108, 234, 0.2) !important;
}
.consent-label {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  cursor: pointer;
  padding-top: 2px;
}
.signature-meta-card {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 18px 0;
  align-items: center;
  border-top: 1px solid #e8eef6;
}
.signature-meta-label {
  font-size: 15px;
  font-weight: 700;
  color: #00095b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.signature-meta-value {
  font-size: 15px;
  font-weight: 500;
  color: #1f2937;
  line-height: 1.5;
}
.signature-panel {
  padding: 18px 0 0;
  background: transparent;
  border-top: 1px solid #e8eef6;
}
.signature-panel-header {
  margin-bottom: 14px;
  padding-bottom: 0;
  border-bottom: 0;
}
.signature-panel-title {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: #00095b;
  line-height: 1.4;
}
.signature-canvas-shell {
  width: 100%;
  padding: 4px;
  border: 1px solid #d7e1ef;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: none;
  transition: all 200ms ease;
}
.signature-canvas-shell:focus-within {
  border: 2px solid #046cea;
  background: #f8fbff;
  box-shadow: 0 2px 8px rgba(4, 108, 234, 0.12), inset 0 1px 2px rgba(15, 23, 42, 0.08);
}
.signature-canvas-shell.is-drawing {
  border: 2px solid #046cea;
  background: #f0f7ff;
  box-shadow: 0 0 0 3px rgba(4, 108, 234, 0.18), inset 0 1px 3px rgba(15, 23, 42, 0.1);
}
.signature-canvas-shell.has-error {
  border: 2px solid #dc2626;
  background: #fff5f5;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.15);
  animation: shake 0.35s ease;
}
@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  20% {
    transform: translateX(-5px);
  }
  40% {
    transform: translateX(5px);
  }
  60% {
    transform: translateX(-4px);
  }
  80% {
    transform: translateX(4px);
  }
}
:host ::ng-deep .consent-check .p-checkbox,
:host ::ng-deep .consent-check .ui-chkbox {
  margin-top: 2px;
  flex: 0 0 auto;
}
.contract-created-action {
  display: flex;
  justify-content: center;
  align-items: center;
}
.contract-created-download {
  width: min(420px, 100%);
  height: 48px;
  padding: 0 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: 10px;
  background: #046cea;
  border: 1px solid #046cea;
  color: #ffffff;
  font-size: 15pt;
  font-weight: 500;
}
.contract-created-download:hover:not(:disabled) {
  background: #044ea7;
}
.contract-created-download:disabled {
  background-color: #f5f5f5;
  border: 1px solid #aaaaaa;
  color: #6f6f6f;
  cursor: not-allowed;
  opacity: 1;
  pointer-events: none;
}
.contract-created-download.is-loading {
  background-color: #f5f5f5;
  border-color: #aaaaaa;
  color: #6f6f6f;
}
.contract-created-download .pi {
  font-size: 18px;
  color: inherit;
}
@media (max-width: 768px) {
  .btn-next,
  .btn-back {
    width: 100%;
  }
  .signature-consent-section {
    width: calc(100% - 32px);
    margin: 24px 16px 0;
    padding: 0;
  }
  .consent-card,
  .signature-meta-card,
  .signature-panel {
    padding-left: 0;
    padding-right: 0;
  }
  .consent-label,
  .signature-panel-title,
  .signature-meta-value,
  .signature-meta-label {
    font-size: 16px;
  }
  .contract-created-download {
    width: 100%;
    font-size: 13pt;
    padding: 0 16px;
  }
}
/*# sourceMappingURL=payment-signature.component-EUS4JGK5.css.map */
